/**
 * Fetch Single Add-On Product API
 * Feature: 023-flexible-training-product
 */

import axiosInstance from '../axiosInstance';
import { AddOnProduct } from './types';

export const fetchAddOnProduct = async (id: string): Promise<AddOnProduct> => {
  const response = await axiosInstance.get<AddOnProduct>(`/api/add-on-products/${id}`);
  return response.data;
};
